function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var _ref2, _ref3, _ref4;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 14,
    viewBox: "0 0 5 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 11.8333C1.83337 12.2936 2.20647 12.6667 2.66671 12.6667C3.12694 12.6667 3.50004 12.2936 3.50004 11.8333C3.50004 11.3731 3.12694 11 2.66671 11C2.20647 11 1.83337 11.3731 1.83337 11.8333Z",
    stroke: "#979DAD",
    style: (_ref2 = {
      stroke: "#979DAD"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.5922 0.6157 0.6784)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 6.83333C1.83337 7.29357 2.20647 7.66667 2.66671 7.66667C3.12694 7.66667 3.50004 7.29357 3.50004 6.83333C3.50004 6.3731 3.12694 6 2.66671 6C2.20647 6 1.83337 6.3731 1.83337 6.83333Z",
    stroke: "#979DAD",
    style: (_ref3 = {
      stroke: "#979DAD"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.5922 0.6157 0.6784)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 1.83333C1.83337 2.29357 2.20647 2.66667 2.66671 2.66667C3.12694 2.66667 3.50004 2.29357 3.50004 1.83333C3.50004 1.3731 3.12694 1 2.66671 1C2.20647 1 1.83337 1.3731 1.83337 1.83333Z",
    stroke: "#979DAD",
    style: (_ref4 = {
      stroke: "#979DAD"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.5922 0.6157 0.6784)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.345aba85d2c3ad8de4ea991e04f5e912.svg";
export { ForwardRef as ReactComponent };